import { Toaster } from 'sonner';
import { useLocation } from 'react-router-dom';

/** Routes that have bottom UI (footer, primary button, filters bar) - toast appears above them */
const ROUTES_WITH_BOTTOM_UI = [
  '/',
  '/schedule',
  '/my_trainings',
  '/freeze',
  '/support',
  '/shopping',
  '/shopping-cart',
  '/shopping-success',
  '/shopping-error',
  '/register',
  '/otp',
  '/profile',
  '/filters',
  '/error',
];

function hasBottomUI(pathname: string): boolean {
  return ROUTES_WITH_BOTTOM_UI.some(
    (route) => pathname === route || pathname.startsWith(route + '/')
  );
}

export function AppToaster() {
  const { pathname } = useLocation();
  const bottomOffset = hasBottomUI(pathname) ? '100px' : '16px';

  return (
    <Toaster
      theme="dark"
      position="bottom-center"
      offset={{ bottom: bottomOffset, left: '16px', right: '16px' }}
      mobileOffset={{ bottom: bottomOffset, left: '16px', right: '16px' }}
      swipeDirections={['left', 'right']}
      toastOptions={{
        style: {
          background: 'var(--color-bg)',
          border: '1px solid var(--color-third)',
          color: 'var(--color-text)',
        },
      }}
    />
  );
}
